<p *ngIf="_text === 'wrong'" class="help is-wrong" [class.hide]="_hide"><i class="fal fa-times"></i></p>
<p *ngIf="_text === 'wright'" class="help is-wright" [class.hide]="_hide"><i class="fal fa-check"></i></p>
<p *ngIf="_text === 'warning'" class="help is-warning" [class.hide]="_hide"><i class="fas fa-exclamation-triangle"></i></p>
